/**
 * Appstle Subscription Widget — Nimes Custom Styling
 * WIDGET_TYPE_7 — class names from live HTML inspection.
 */
(function () {
  const CREAM  = '#fffbf5';
  const BORDER = '#2c1a0b';
  const TEXT   = '#2c1a0b';
  const MUTED  = 'rgba(44,26,11,0.65)';
  const FONT   = '"Open Sans", sans-serif';

  function assetUrl(filename) {
    const tag = document.querySelector('script[src*="/assets/"]');
    if (tag) return tag.src.replace(/\/assets\/.*$/, '/assets/') + filename;
    return filename;
  }

  const PERKS = [
    { icon: assetUrl('appstle-icon-delivery.svg'),  label: 'Free shipping' },
    { icon: assetUrl('appstle-icon-return.svg'),    label: 'Cancel anytime' },
    { icon: assetUrl('appstle-icon-calendar.svg'),  label: 'Delivery within Sweden: 2–3 business days' },
    { icon: assetUrl('appstle-icon-coins.svg'),     label: 'Save 10% on every order' },
  ];

  const CSS = `
    .appstle_sub_widget, .appstle_sub_widget * {
      font-family: ${FONT} !important;
      box-sizing: border-box !important;
    }

    /* Hide title & tooltip */
    .appstle_widget_title,
    .appstle-tootltip-parent { display: none !important; }

    /* Options stack */
    .appstle_subscription_wrapper {
      display: flex !important;
      flex-direction: column !important;
      gap: 8px !important;
    }

    /* ═══ Subscription card ═══ */
    .appstle_subscription_wrapper_option.appstle_include_dropdown {
      border: 1px solid ${BORDER} !important;
      border-radius: 14px !important;
      overflow: hidden !important;
      background: transparent !important;
      transition: background 0.15s ease !important;
      cursor: pointer !important;
    }

    /* Cream when selected */
    .appstle_subscription_wrapper_option.appstle_include_dropdown.nimes-checked {
      background: ${CREAM} !important;
    }

    /* ── Radio wrapper row: radio + name+badge on left, price on right ── */
    .appstle_subscription_radio_wrapper {
      display: flex !important;
      align-items: center !important;
      padding: 13px 15px !important;
      gap: 0 !important;
    }

    /* Hide native radio input */
    .appstle_subscription_wrapper_option.appstle_include_dropdown input[type="radio"] {
      position: absolute !important;
      opacity: 0 !important;
      pointer-events: none !important;
      width: 0 !important;
      height: 0 !important;
    }

    /* Style Appstle's current radio ring to match the Figma design */
    .appstle_subscription_wrapper_option.appstle_include_dropdown .appstle_circle {
      width: 17px !important;
      height: 17px !important;
      border: 2px solid ${BORDER} !important;
      border-radius: 50% !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin-right: 10px !important;
      background: transparent !important;
    }

    .appstle_subscription_wrapper_option.appstle_include_dropdown .appstle_dot {
      width: 9px !important;
      height: 9px !important;
      border-radius: 50% !important;
      background: #3a3a3a !important;
      display: none !important;
    }

    /* Filled dot only when this subscription radio is selected */
    .appstle_subscription_wrapper_option.appstle_include_dropdown input[type="radio"]:checked + label .appstle_dot {
      display: block !important;
    }

    /* Label: just let it flex naturally beside the radio */
    .appstle_subscription_wrapper_option.appstle_include_dropdown .appstle_radio_label {
      display: flex !important;
      align-items: center !important;
      flex: 1 !important;
      cursor: pointer !important;
      gap: 0 !important;
      padding: 0 !important;
    }

    /* Name + badge wrapper */
    .appstle-text-and-badge-wrapper {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
    }

    .appstle_subscribe_save_text {
      font-size: 15px !important;
      font-weight: 400 !important;
      color: ${TEXT} !important;
      line-height: 1.6 !important;
    }

    /* SAVE badge */
    .appstle-save-badge {
      background: #000 !important;
      color: #fff !important;
      font-size: 8.8px !important;
      font-weight: 700 !important;
      letter-spacing: 0.9px !important;
      text-transform: uppercase !important;
      border-radius: 11px !important;
      padding: 2px 7px !important;
      line-height: 1.6 !important;
      white-space: nowrap !important;
      display: inline-block !important;
    }

    /* Price — right side of the radio wrapper row */
    .appstle_subscription_amount_wrapper {
      display: flex !important;
      align-items: baseline !important;
      gap: 4px !important;
      margin-left: auto !important;
      flex-shrink: 0 !important;
    }

    .appstle_subscription_wrapper_option.appstle_include_dropdown .appstle_subscription_amount {
      font-size: 13px !important;
      font-weight: 400 !important;
      color: red !important;
      white-space: nowrap !important;
    }

    .appstle_subscription_compare_amount {
      font-size: 13px !important;
      font-weight: 400 !important;
      color: ${TEXT} !important;
      text-decoration: line-through !important;
      white-space: nowrap !important;
    }

    /* Hide sr-only spans */
    .appstle_subscription_amount-appstle-sr-only,
    .appstle_subscription_compare_amount-appstle-sr-only {
      position: absolute !important;
      width: 1px !important; height: 1px !important;
      overflow: hidden !important; clip: rect(0,0,0,0) !important;
    }

    /* ── Frequency + perks: hidden when not selected, shown when selected ── */
    .appstle_subscribe_option,
    .nimes-perks {
      display: none !important;
    }

    .appstle_subscription_wrapper_option.appstle_include_dropdown.nimes-checked .appstle_subscribe_option,
    .appstle_subscription_wrapper_option.appstle_include_dropdown.nimes-checked .nimes-perks {
      display: block !important;
    }

    .appstle_subscription_wrapper_option.appstle_include_dropdown.nimes-checked .nimes-perks {
      display: flex !important;
    }

    /* Frequency section layout */
    .appstle_subscribe_option {
      padding: 0 15px 10px 15px !important;
    }

    /* Thin divider above frequency section */
    .nimes-divider {
      border: none !important;
      border-top: 1px solid rgba(44,26,11,0.18) !important;
      margin: 0 15px 10px !important;
    }

    /* Frequency grid: [DELIVERY FREQUENCY + description] | [dropdown] */
    .appstle_subscribe_option_grid {
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      gap: 16px !important;
    }

    /* Left col built by JS */
    .nimes-freq-left {
      display: flex !important;
      flex-direction: column !important;
      gap: 3px !important;
      flex: 1 !important;
      min-width: 0 !important;
    }

    .appstle_select_label {
      font-size: 13px !important;
      font-weight: 400 !important;
      color: ${TEXT} !important;
      text-transform: uppercase !important;
      letter-spacing: 0.3px !important;
      display: block !important;
    }

    .appstleSelectedSellingPlanOptionDescription {
      font-size: 12px !important;
      color: ${MUTED} !important;
      margin: 0 !important;
    }
    .appstleSelectedSellingPlanOptionDescription p { margin: 0 !important; }

    /* Hide description from its original position (moved into left col by JS) */
    .appstle_subscribe_option > .appstleSelectedSellingPlanOptionDescription {
      display: none !important;
    }

    /* Dropdown */
    .appstle_custom_select { flex-shrink: 0 !important; }

    .appstle_select {
      -webkit-appearance: none !important;
      appearance: none !important;
      background-color: #fff !important;
      border: 1px solid ${BORDER} !important;
      border-radius: 9px !important;
      padding: 0 36px 0 14px !important;
      height: 45px !important;
      min-width: 210px !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      color: ${TEXT} !important;
      text-transform: uppercase !important;
      letter-spacing: 0.4px !important;
      cursor: pointer !important;
      font-family: ${FONT} !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' fill='none'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%232c1a0b' stroke-width='1.5'/%3E%3C/svg%3E") !important;
      background-repeat: no-repeat !important;
      background-position: right 12px center !important;
    }

    /* ── Perks row ── */
    .nimes-perks {
      align-items: center !important;
      flex-wrap: wrap !important;
      gap: 4px 5px !important;
      padding: 10px 15px 13px !important;
      border-top: 1px solid rgba(44,26,11,0.18) !important;
    }

    .nimes-perk {
      display: flex !important;
      align-items: center !important;
      gap: 5px !important;
      font-size: 11px !important;
      color: #301a08 !important;
      letter-spacing: -0.1px !important;
      white-space: nowrap !important;
    }

    .nimes-perk img {
      width: 17px !important;
      height: 17px !important;
      display: block !important;
      flex-shrink: 0 !important;
    }

    /* Hide junk */
    .appstle_bundle_discount_amount,
    .appstle_one_time_description_text,
    .appstle_subscription_description_text { display: none !important; }
    #appstle_subscription_widget0 .appstle_subscribe_option {
    margin-left: 0;
    margin-left: 25px!important;
    padding: 0!important;
}

hr.nimes-divider {
    border-color: #301A08!important;
    margin-left: 25px!Important;
    margin-right: 0!important;
}

#appstle_subscription_widget0 .appstle_selected_background.appstle-active-option .appstle_subscription_radio_wrapper {
    padding: 0!important;
    padding-bottom: 10px!important;
}

div .appstle_custom_select {
    order: 23;
    position: absolute;
    right: 0;
}

 div .appstle_custom_select:before {
    display: none;
}

.appstle_subscribe_option_grid {
    flex-direction: column;
    align-items: flex-start!important;
    gap: 0!important;
    position: relative;
    min-height: 50px;
    /* display: block!important; */
    justify-content: initial!important;
}
.appstle_subscription_wrapper_option.appstle_include_dropdown.nimes-checked .nimes-perks {
    justify-content: flex-start;
}
@media screen and (max-width: 1450px) {
span.nimes-perk {
    min-width: 200px;
}

}


.nimes-freq-left {
    flex: auto!important;
    gap: 0!important;
    max-height: 20px!Important;
}

.appstle_subscription_wrapper_option.appstle_include_dropdown.nimes-checked .nimes-perks {
    padding-left: 0!important;
    margin-left: 25px!Important;
    padding: 0!important;
    padding-top: 15px!Important;
    margin-top: 12px!Important;
    border-color: #301A08!important;
    justify-content: space-between;
}

.appstle-tootltip-parent {
    display: block!Important;
    margin-bottom: 20px!Important;
}

#appstle_subscription_widget0 .appstle_subscription_wrapper {
    margin-bottom: 20px!Important;
}

#appstle_subscription_widget0 .appstle_selected_background:not(.appstle-active-option) {}

#appstle_subscription_widget0 .appstle_selected_background:not(.appstle-active-option) hr.nimes-divider {
    display: none!important;
}

#appstle_subscription_widget0 .appstle_selected_background:not(.appstle-active-option) .appstle_subscribe_option_grid {
    display: none!important;
}

#appstle_subscription_widget0 .appstle_subscription_radio_wrapper {
    padding: 0!Important;
}


@media screen and (max-width: 1360px) and (min-width: 1025px) {
  .appstleSelectedSellingPlanOptionDescription {
      max-width: 190px;
      line-height: 1.3em;
  }
  }
  div .appstle_custom_select {
      top: 50%;
      transform: translateY(-50%);
  }
  @media screen and (max-width: 1024px) {
  div .appstle_custom_select {
      position: static!important;
      margin-top: 10px;
      transform: none;
  }
      .nimes-freq-left {
    max-height: 100% !important;
}
      
  }
  @media screen and (max-width: 768px) {
  
  .appstle_subscription_wrapper_option.appstle_include_dropdown.nimes-checked .nimes-perks {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start!important;
  }
  }
  
  `;

  function injectStyles() {
    if (document.getElementById('nimes-appstle-css')) return;
    const s = document.createElement('style');
    s.id = 'nimes-appstle-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function buildPerks() {
    const row = document.createElement('div');
    row.className = 'nimes-perks';
    PERKS.forEach(({ icon, label }) => {
      const p = document.createElement('span');
      p.className = 'nimes-perk';
      const img = document.createElement('img');
      img.src = icon; img.alt = '';
      p.appendChild(img);
      p.appendChild(document.createTextNode(label));
      row.appendChild(p);
    });
    return row;
  }

  function reorderOptions(widget) {
    const wrapper = widget.querySelector('.appstle_subscription_wrapper');
    if (!wrapper) return;
    const sub     = wrapper.querySelector('.appstle_subscription_wrapper_option.appstle_include_dropdown');
    const onetime = wrapper.querySelector('.appstle_subscription_wrapper_option:not(.appstle_include_dropdown)');
    if (!sub || !onetime) return;
    if (onetime.compareDocumentPosition(sub) & Node.DOCUMENT_POSITION_FOLLOWING) {
      wrapper.insertBefore(sub, onetime);
    }
  }

  /* Inject custom radio ring before the label (keeps original label intact) */
  function injectRadio(subOption) {
    // Intentionally no-op: we now use Appstle's own radio UI.
  }

  /* Move the description into the frequency grid left-col */
  function restructureFrequency(subOption) {
    if (subOption.dataset.nimesFreqDone) return;
    subOption.dataset.nimesFreqDone = '1';

    const grid    = subOption.querySelector('.appstle_subscribe_option_grid');
    const labelEl = subOption.querySelector('.appstle_select_label');
    const selectW = subOption.querySelector('.appstle_custom_select');
    const descEl  = subOption.querySelector('.appstleSelectedSellingPlanOptionDescription');
    if (!grid || !labelEl || !selectW) return;

    const leftCol = document.createElement('div');
    leftCol.className = 'nimes-freq-left';
    leftCol.appendChild(labelEl);          // move (not clone) to keep events
    if (descEl) leftCol.appendChild(descEl);

    grid.innerHTML = '';
    grid.appendChild(leftCol);
    grid.appendChild(selectW);
  }

  /* Inject divider before frequency section */
  function injectDivider(subOption) {
    if (subOption.querySelector('.nimes-divider')) return;
    const freqSection = subOption.querySelector('.appstle_subscribe_option');
    if (!freqSection) return;
    const hr = document.createElement('hr');
    hr.className = 'nimes-divider';
    freqSection.before(hr);
  }

  function updateState(widget) {
    const subOption = widget.querySelector('.appstle_subscription_wrapper_option.appstle_include_dropdown');
    if (!subOption) return;
    const radio   = subOption.querySelector('input[type="radio"]');
    const checked = radio && radio.checked;
    subOption.classList.toggle('nimes-checked', checked);
    subOption.style.setProperty('background', checked ? CREAM : 'transparent', 'important');
  }

  function enhanceWidget(widget) {
    if (widget.dataset.nimesEnhanced) return;
    const subOption = widget.querySelector('.appstle_subscription_wrapper_option.appstle_include_dropdown');
    if (!subOption) return;

    widget.dataset.nimesEnhanced = '1';

    reorderOptions(widget);
    restructureFrequency(subOption);
    injectDivider(subOption);

    if (!subOption.querySelector('.nimes-perks')) {
      const freqSection = subOption.querySelector('.appstle_subscribe_option');
      freqSection ? freqSection.after(buildPerks()) : subOption.appendChild(buildPerks());
    }

    updateState(widget);
    widget.addEventListener('change', () => updateState(widget));
    widget.addEventListener('click',  () => setTimeout(() => updateState(widget), 30));
  }

  function processAll() {
    document.querySelectorAll('.appstle_sub_widget').forEach(enhanceWidget);
  }

  function init() {
    injectStyles();
    processAll();
    new MutationObserver(processAll).observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
